<template>
    <section class="section case-sec">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="section__header--secondary">
                        <div class="row align-items-center items-gap">
                            <div class="col-12 col-lg-8">
                                <h2 class="h2 wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                                    tech AI Use Cases
                                </h2>
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="case-pagination cmn-pagination"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="case__slider">
                        <div class="case__slider-container">
                            <div class="swiper-wrapper">
                                <div class="case__slider-single swiper-slide case-slider-1">
                                    <div class="thumb">
                                        <i class="tech-camera"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Videos</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-2">
                                    <div class="thumb">
                                        <i class="tech-cap"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">E-learning</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-3">
                                    <div class="thumb">
                                        <i class="tech-plug"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">tech AI API</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-4">
                                    <div class="thumb">
                                        <i class="tech-speaker"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">IVR Systems</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-5">
                                    <div class="thumb">
                                        <i class="tech-headphone"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Audio Articles</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-6">
                                    <div class="thumb">
                                        <i class="tech-camera"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Videos</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-7">
                                    <div class="thumb">
                                        <i class="tech-cap"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">E-learning</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-8">
                                    <div class="thumb">
                                        <i class="tech-plug"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">tech AI API</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-9">
                                    <div class="thumb">
                                        <i class="tech-speaker"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">IVR Systems</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="case__slider-single swiper-slide case-slider-10">
                                    <div class="thumb">
                                        <i class="tech-headphone"></i>
                                    </div>
                                    <div class="content">
                                        <h5 class="h5">Audio Articles</h5>
                                        <p>
                                            Clear, consistent, and professional voices for marketing,
                                            explainer, product, and YouTube videos.
                                        </p>
                                        <router-link to="/use-case-details">
                                            View Details
                                            <i class="fa-solid fa-angles-right"></i>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script scoped>
    import Swiper from 'swiper';
    import 'swiper/swiper-bundle.css';
    
    export default {
        name: "Case",
        mounted() {
            new Swiper('.case__slider-container', {
                slidesPerView: 'auto',
                slidesPerGroup: 2,
                spaceBetween: 30,
                loop: true,
                speed: 1000,
                pagination: {
                    el: '.case-pagination',
                    clickable: true,
                },
                autoplay: {
                    delay: 4000,
                },
            });
        },
    };
</script>

<style scoped>
    .case__slider-container {
        overflow: hidden;
        user-select: none;
    }

    .case-slider-1 {
        background-image: url('~@/assets/images/case/one.png');
    }

    .case-slider-2 {
        background-image: url('~@/assets/images/case/three.png');
    }

    .case-slider-3 {
        background-image: url('~@/assets/images/case/two.png');
    }

    .case-slider-4 {
        background-image: url('~@/assets/images/case/four.png');
    }

    .case-slider-5 {
        background-image: url('~@/assets/images/case/five.png');
    }

    .case-slider-6 {
        background-image: url('~@/assets/images/case/one.png');
    }

    .case-slider-7 {
        background-image: url('~@/assets/images/case/three.png');
    }

    .case-slider-8 {
        background-image: url('~@/assets/images/case/two.png');
    }

    .case-slider-9 {
        background-image: url('~@/assets/images/case/four.png');
    }

    .case-slider-10 {
        background-image: url('~@/assets/images/case/five.png');
    }
</style>


// WEBPACK FOOTER //
// src/components/page_components/home/Case.vue